<script setup lang="ts">
import { GetTransportSourcesQuery } from "@/graphql";
import NumberInput from "@/components/Reusables/Inputs/NumberInput.vue";

withDefaults(
  defineProps<{
    emissionFactor: GetTransportSourcesQuery["transportSource"][0]["transportEmissionFactors"][0];
    value: string;
    /** Inert and greyed out — `NumberInput` already renders the disabled look. Set for a Viewer (RTLCA-5581). */
    disabled?: boolean;
  }>(),
  { disabled: false }
);

const emit = defineEmits<{
  (e: "change", value: number): void;
}>();

const handleChange = (value: number | null) => {
  emit("change", value || 0);
};
</script>

<template>
  <NumberInput
    :key="emissionFactor.id"
    :align-right="true"
    class="text-slate-600"
    color="primary"
    :disabled="disabled"
    :positive="true"
    :value="value"
    @update:value="handleChange" />
</template>
